import { Locale } from '__generated__/graphql';

export interface Translation {
  attribute?: string;
  locale: Locale;
  value: string | null;
}

/**
 * Returns the number of non-empty translations. Does not count the translation for the default locale.
 */
export const countTranslations = (translations: Translation[], defaultLocale: Locale) => (
  translations.filter(({ locale, value }) => locale !== defaultLocale && value !== null).length
);

export const translationsForAttribute = (translations: Translation[], attribute: string) => (
  translations.filter((translation) => translation.attribute === attribute).map(({ locale, value }) => ({
    locale,
    value,
  }))
);
